export default __webpack_public_path__ + "static/media/arrow-up.90980b0f.svg";